import * as React from 'react';

import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import {
    ContextualMenu,
    DirectionalHint,
    IContextualMenuItem,
} from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { Button, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { ColorPickerItem } from '../utils/Colors';
import { FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import Color from 'color';

let styles = require('./ColorPicker.scss');
let classNames = require('classnames');

export interface ColorPickerProps {
    menuTargetElement: HTMLElement;
    colors: ColorPickerItem[];
    onDismissMenu: () => void;
    onSelectColor: (value: ColorPickerItem) => void;
    shouldFocusOnMount?: boolean;
    selectedColor?: string;
}

export class ColorPicker extends React.Component<ColorPickerProps, {}> {
    private isColorPickerItemChecked(color: ColorPickerItem) {
        return (
            this.props.selectedColor !== null &&
            Color(color.code)
                .rgb()
                .string() ===
                Color(this.props.selectedColor)
                    .rgb()
                    .string()
        );
    }

    private renderColorMenuItem = (item: IContextualMenuItem): JSX.Element => {
        let color = item.data as ColorPickerItem;
        let inlineStyles: React.CSSProperties = { backgroundColor: color.code };
        if (color.borderColor) {
            inlineStyles.borderColor = color.borderColor;
        }

        let ariaProps: AriaProperties = {
            role: AriaRoles.menuitemcheckbox,
            label: color.name,
            checked: this.isColorPickerItemChecked(color),
        };

        return (
            <Button
                buttonType={ButtonType.normal}
                data-is-focusable={true}
                title={color.name}
                onClick={() => this.onSelectColor(color)}
                key={item.key}
                {...generateDomPropertiesForAria(ariaProps)}>
                <div className={styles.colorSquare} style={inlineStyles} />
            </Button>
        );
    };

    private onSelectColor = (color: ColorPickerItem) => {
        this.props.onDismissMenu();
        this.props.onSelectColor(color);
    };

    render() {
        let { onDismissMenu, menuTargetElement, shouldFocusOnMount } = this.props;
        let pickerStyle = classNames(styles.colorPickerContainer);
        return (
            <ContextualMenu
                className={pickerStyle}
                shouldFocusOnMount={shouldFocusOnMount}
                target={menuTargetElement}
                directionalHint={DirectionalHint.bottomLeftEdge}
                onDismiss={onDismissMenu}
                focusZoneProps={{ direction: FocusZoneDirection.bidirectional }}
                items={this.props.colors.map((color: ColorPickerItem) => {
                    return {
                        key: color.name,
                        name: color.name,
                        onRender: this.renderColorMenuItem,
                        data: color,
                        className: styles.colorMenuItem,
                    };
                })}
            />
        );
    }
}
